// The `/admin` hub — page chrome plus four nav cards into the actual admin
// surfaces. Each destination page still owns its own server-gated 403 (the
// same server-owned-gate pattern as AccessPage / AnalyticsPage /
// CodeMapAdminPage); the `useIsAdmin` probe here is presentation only, so a
// non-admin who navigates straight to /admin is told so instead of being
// handed four tiles that all dead-end on a 403.

import type { JSX } from "react";

import { useT } from "../i18n/index.js";

import { useIsAdmin } from "./useIsAdmin";

interface AdminHomePageProps {
  readonly onBack: () => void;
  readonly onOpenAccess: () => void;
  readonly onOpenCodeMap: () => void;
  readonly onOpenAnalytics: () => void;
  readonly onOpenKeys: () => void;
}

export const AdminHomePage = ({
  onBack,
  onOpenAccess,
  onOpenCodeMap,
  onOpenAnalytics,
  onOpenKeys,
}: AdminHomePageProps): JSX.Element => {
  const t = useT();
  const isAdmin = useIsAdmin();

  return (
    <div className="loom-dashboard admin-home-page">
      <header className="admin-access-head">
        <button className="admin-access-back" onClick={onBack} type="button">
          ← {t("admin.home.back")}
        </button>
        <div>
          <h1 className="admin-access-title">{t("admin.home.title")}</h1>
          <p className="admin-access-subtitle">{t("admin.home.subtitle")}</p>
        </div>
      </header>
      {isAdmin === false ? (
        <div className="admin-access-state admin-access-denied">
          <h2>{t("admin.codeMap.denied.title")}</h2>
          <p>{t("admin.codeMap.denied.body")}</p>
        </div>
      ) : (
      <div className="admin-home-links">
        <button type="button" className="admin-home-link" onClick={onOpenAccess}>
          <span className="admin-home-link-title">{t("admin.home.link.access")}</span>
          <span className="admin-home-link-desc">{t("admin.home.link.accessDesc")}</span>
        </button>
        <button type="button" className="admin-home-link" onClick={onOpenCodeMap}>
          <span className="admin-home-link-title">{t("admin.home.link.codeMap")}</span>
          <span className="admin-home-link-desc">{t("admin.home.link.codeMapDesc")}</span>
        </button>
        <button type="button" className="admin-home-link" onClick={onOpenAnalytics}>
          <span className="admin-home-link-title">{t("admin.home.link.analytics")}</span>
          <span className="admin-home-link-desc">{t("admin.home.link.analyticsDesc")}</span>
        </button>
        <button type="button" className="admin-home-link" onClick={onOpenKeys}>
          <span className="admin-home-link-title">{t("admin.home.link.keys")}</span>
          <span className="admin-home-link-desc">{t("admin.home.link.keysDesc")}</span>
        </button>
      </div>
      )}
    </div>
  );
};
